export default __webpack_public_path__ + "static/media/Group1749.5c0f24b1.svg";